import {
  gitlabAuthApiRef,
  googleAuthApiRef,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  KubernetesAuthProviders,
  kubernetesAuthProvidersApiRef,
} from '@backstage/plugin-kubernetes-react';
import { kubernetesPage } from './kubernetesPage';

const kubernetesAuthProvidersApi = ApiBlueprint.make({
  name: 'auth-providers',
  params: defineParams =>
    defineParams({
      api: kubernetesAuthProvidersApiRef,
      deps: {
        gitlabAuthApi: gitlabAuthApiRef,
        googleAuthApi: googleAuthApiRef,
        microsoftAuthApi: microsoftAuthApiRef
      },
      factory: ({
        gitlabAuthApi,
        googleAuthApi,
        microsoftAuthApi
      }) => {
        return new KubernetesAuthProviders({
          microsoftAuthApi,
          googleAuthApi,
          oidcProviders: {
            gitlab: gitlabAuthApi,
            google: googleAuthApi,
            microsoft: microsoftAuthApi
          },
        });
      }
    }),
});

export const kubernetesModule = createFrontendModule({
  pluginId: 'kubernetes',
  extensions: [kubernetesAuthProvidersApi, kubernetesPage],
});
